exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete-field {\n  position: relative;\n}\n.autocomplete-field .activity-indicator {\n  right: 0.5rem;\n  bottom: 0.5rem;\n  position: absolute;\n}\n.autocomplete-list-wrapper {\n  position: absolute;\n  z-index: 10;\n  width: 100%;\n  top: 100%;\n  background: white;\n}\n.autocomplete-list {\n  margin: 0;\n  padding: 0;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n          box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n}", ""]);

// exports
